const ALL_LANGUAGES = [
    { code: 'en',    name: 'English',  native: 'English'  },
    { code: 'ru',    name: 'Russian',  native: 'Русский'  },
    { code: 'fr',    name: 'French',   native: 'Français' },
    { code: 'es',    name: 'Spanish',  native: 'Español'  },
    { code: 'de',    name: 'German',   native: 'Deutsch'  },
    { code: 'zh-CN', name: 'Chinese',  native: '中文'      },
    { code: 'ar',    name: 'Arabic',   native: 'العربية'  },
];

const LANG_NAMES = Object.fromEntries(ALL_LANGUAGES.map(l => [l.code, l.name]));
const LANG_CODES = Object.fromEntries(ALL_LANGUAGES.map(l => [
    l.code,
    l.code === 'zh-CN' ? 'ZH' : l.code.toUpperCase().slice(0, 2)
]));

// Exposed for backward-compat (auto-translate.js and similar may reference these)
window.LANG_NAMES = LANG_NAMES;
window.LANG_CODES = LANG_CODES;

function initSwitcher(el) {
    const defaultLang = el.dataset.lsDefault || 'en';
    const trigger     = el.querySelector('.ls-trigger');
    const dropdown    = el.querySelector('.ls-dropdown');
    const codeEl      = el.querySelector('.ls-code');
    const nameEl      = el.querySelector('.ls-name');
    const options     = el.querySelectorAll('.ls-option');

    if (!trigger || !dropdown) return;

    let current = siteStorage.get('selected_language') || defaultLang;

    /* ── Display ── */
    function setDisplay(lang) {
        if (codeEl) codeEl.textContent = LANG_CODES[lang] || 'EN';
        if (nameEl) nameEl.textContent = LANG_NAMES[lang] || 'Language';
        options.forEach(opt => {
            const active = opt.dataset.lsCode === lang;
            opt.setAttribute('aria-selected', String(active));
            opt.classList.toggle('ls-active', active);
        });
    }

    /* ── Dropdown open / close ── */
    function open() {
        dropdown.classList.add('ls-open');
        requestAnimationFrame(() => requestAnimationFrame(() => dropdown.classList.add('ls-visible')));
        trigger.setAttribute('aria-expanded', 'true');
        el.classList.add('ls-is-open');
    }

    function close() {
        dropdown.classList.remove('ls-visible');
        dropdown.addEventListener('transitionend', () => dropdown.classList.remove('ls-open'), { once: true });
        trigger.setAttribute('aria-expanded', 'false');
        el.classList.remove('ls-is-open');
    }

    /* ── Events ── */
    trigger.addEventListener('click', e => {
        e.stopPropagation();
        el.classList.contains('ls-is-open') ? close() : open();
    });

    options.forEach(opt => {
        opt.addEventListener('click', () => {
            const lang = opt.dataset.lsCode;
            current = lang;
            siteStorage.set('selected_language', lang);
            window.dispatchEvent(new CustomEvent('language-changed', { detail: { language: lang } }));
            setDisplay(lang);
            close();
        });
    });

    document.addEventListener('click', e => {
        if (el.classList.contains('ls-is-open') && !el.contains(e.target)) close();
    });

    window.addEventListener('language-changed',  e => { current = e.detail.language; setDisplay(current); });
    window.addEventListener('language-switched', e => { current = e.detail.language; setDisplay(current); });

    setDisplay(current);
}

function init() {
    document.querySelectorAll('.ls-switcher:not([data-ls-inited])').forEach(el => {
        el.setAttribute('data-ls-inited', '');
        initSwitcher(el);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

document.addEventListener('htmx:afterSwap', () => {
    document.querySelectorAll('.ls-switcher:not([data-ls-inited])').forEach(el => {
        el.setAttribute('data-ls-inited', '');
        initSwitcher(el);
    });
});
